<template>
  <div class="dialog-wechat-account-setting-wrapper">
    <el-dialog width="50%" :title="`公众号设置（${user.username}）`" :visible="visible" @open="onDialogOpen" @close="onDialogClose">
      <div class="empty-wrapper" v-if="wechatAccount.appId === ''">
        <p>
          该商户没有配置公众号 ~~~
        </p>

        <div class="operation-box">
          <el-button type="danger" @click="onWechatAccountCreateClick">
            添加公众号
          </el-button>
          <el-button @click="onDialogClose">
            关闭
          </el-button>
        </div>
      </div>

      <div class="content-wrapper" v-else>

        <el-tabs
          :stretch="true"
          :laze="false"
          type="border-card"
          @tab-click="onTabClick"
          ref="wechatAccountSettingTabs"
          v-model="wechatAccountSettingTab">

          <el-tab-pane label="公众号配置" name="wechatAccount">
            <div class="row-list">
              <div class="row">
                <span class="label">公众号名称：</span>
                <el-tooltip placement="bottom">
                  <div slot="content">
                    OriginID: {{ wechatAccount.originalId }} <br/>
                    AppID: {{ wechatAccount.appId }} <br/>
                    AppSecret: {{ wechatAccount.appSecret }} <br/>
                    EncodingAesKey: {{ wechatAccount.encodingAesKey }}
                  </div>
                  <span class="value">{{ wechatAccount.accountName }}</span>
                </el-tooltip>
              </div>

              <div class="row">
                <span class="label">域名：</span>
                <span class="value">{{ wechatAccount.domain.join(', ') }}</span>
              </div>
              <div class="row">
                <span class="label">离线通知模板：</span>
                <span class="value">{{ wechatAccount.offlineTpl }}</span>
              </div>
              <div class="row">
                <span class="label">退款通知模板：</span>
                <span class="value">{{ wechatAccount.refundTpl }}</span>
              </div>
              <div class="row">
                <span class="label">设备异常通知模板：</span>
                <span class="value">{{ wechatAccount.abnormalTpl }}</span>
              </div>
              <div class="row">
                <span class="label">库存不足通知模板：</span>
                <span class="value">{{ wechatAccount.stockTpl }}</span>
              </div>
              <div class="row">
                <span class="label">备注：</span>
                <span class="value">{{ wechatAccount.remarks || '无' }}</span>
              </div>
            </div>

            <div class="operation-box">
              <el-button
                type="danger"
                @click="onWechatAccountDeleteClick">删除</el-button>
              <el-button
                type="primary"
                @click="onWechatAccountUpdateClick">编辑</el-button>
              <el-button
                @click="onDialogClose">关闭</el-button>
            </div>
          </el-tab-pane>

          <el-tab-pane label="自定义菜单" name="menu">
            <div class="empty-wrapper" v-if="JSON.stringify(menu) === '{}'">
              <p>
                暂无自定义菜单～～～
              </p>

              <el-button
                type="danger"
                @click="onWechatMenuCreate" >添加自定义菜单</el-button>
              <el-button @click="onDialogClose">关闭</el-button>
            </div>
            <div v-else>
              <el-input
                type="textarea"
                :autosize="{ minRows: 10, maxRows: 15 }"
                v-model="menuStr"
                disabled/>

              <div class="operation-box">
                <el-button
                  type="danger"
                  @click="onWechatMenuEdit">修改自定义菜单</el-button>
                <el-button
                  @click="onDialogClose">关闭</el-button>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="自动回复" name="autoReply">
            <div>
              <custom-table
                :data="autoReplyList">

                <el-table-column
                  prop="reply_type"
                  label="自动回复类型"
                  align="center"
                  header-align="center">
                  <template slot-scope="scope">
                    <el-tag :type="replyTypeTagEnum[scope.row.reply_type]">
                      {{ replyTypeEnum[scope.row.reply_type] }}
                    </el-tag>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="reply_msg"
                  label="回复消息内容"
                  align="center"
                  header-align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.reply_msg.length > 0">
                      <el-tooltip placement="top">
                        <div slot="content">
                          <div>
                            消息类型 - 消息内容
                          </div>
                          <hr>
                          <div v-for="(msg, index) in scope.row.reply_msg"
                             :key="`msg-${index}`">
                            {{ replyMsgTypeEnum[msg.type] }} - {{ msg.type === 'text' ? msg.content : msg.media_id }}
                          </div>
                        </div>
                        <div>
                          {{ scope.row.reply_msg[0].content || scope.row.reply_msg[0].media_id || '无' }}
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-else>
                      无
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="key_word"
                  label="关键词"
                  align="center"
                  header-align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.key_word.length > 0">
                      <el-tooltip placement="top">
                        <div slot="content">
                          <div>
                            关键词类型 - 关键词内容
                          </div>
                          <hr>
                          <div v-for="(keyWord, index) in scope.row.key_word"
                             :key="`key-word-${index}`">
                            {{ keyWordMatchEnum[keyWord.match] }} - {{ keyWord.key }}
                          </div>
                        </div>
                        <div>
                          {{ scope.row.key_word[0].key || '无' }}
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-else>
                      无
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  label="操作"
                  width="200"
                  header-align="center">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      @click="onAutoReplyEdit(scope.row)">
                      编辑
                    </el-button>
                    <el-button
                      size="mini"
                      @click="onAutoReplyDelete(scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>

              </custom-table>

              <div class="operation-box">
                <el-button
                  type="danger"
                  @click="onAutoReplyCreate">添加自动回复</el-button>
                <el-button
                  @click="onDialogClose">关闭</el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'

import wechatAccountApi from '@/api/wechatAccountApi'
import wechatAutoReplyApi from '@/api/wechatAutoReplyApi'

export default {
  name: 'DialogWechatAccountSetting',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  components: {
    CustomTable
  },
  data () {
    return {
      replyTypeEnum: {
        sub: '关注后回复',
        rev: '收到消息后回复',
        key: '关键词回复'
      },
      replyTypeTagEnum: {
        sub: 'info',
        rev: 'danger',
        key: 'success'
      },
      replyMsgTypeEnum: {
        text: '文本',
        image: '图片'
      },
      keyWordMatchEnum: {
        full: '完全匹配',
        regex: '模糊匹配'
      },

      wechatAccount: {
        accountName: '',
        originalId: '',
        userId: '',
        appId: '',
        appSecret: '',
        token: '',
        encodingAesKey: '',
        domain: '',
        offlineTpl: '',
        refundTpl: '',
        abnormalTpl: '',
        stockTpl: '',
        remarks: ''
      },

      menu: {},
      menuStr: '',

      autoReplyList: [
      ],
      autoReplyCount: 0,

      wechatAccountSettingTab: 'wechatAccount'
    }
  },
  methods: {
    onWechatAccountCreateClick () {
      this.$emit('wechat-account-create')
    },
    onWechatAccountUpdateClick () {
      this.$emit('wechat-account-update', this.wechatAccount)
    },
    async onWechatAccountDeleteClick () {
      try {
        await this.$confirm('此操作将永远删除微信公众号', '是否继续', '删除微信公众号', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.$emit('wechat-account-delete', this.wechatAccount)
      } catch (err) {
        console.log(err)
      }
    },

    onWechatMenuCreate () {
      this.$emit('wechat-menu-create', this.wechatAccount)
    },
    onWechatMenuEdit () {
      this.$emit('wechat-menu-update', this.wechatAccount, this.menu)
    },

    onAutoReplyCreate () {
      this.$emit('wechat-auto-reply-create', this.wechatAccount)
    },
    onAutoReplyEdit (autoReply) {
      this.$emit('wechat-auto-reply-update', this.wechatAccount, autoReply)
    },
    async onAutoReplyDelete (autoReply) {
      try {
        await this.$confirm('此操作将永远删除微信公众号自动回复', '是否继续', '删除微信公众号自动回复', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.$emit('wechat-auto-reply-delete', this.wechatAccount, autoReply)
      } catch (err) {
        console.log(err)
      }
    },

    onTabClick (tab) {
    },
    async onDialogOpen () {
      await this.getWechatAccount()

      if (this.wechatAccount.appId === '') {
        return
      }
      await this.getMenu()
      await this.getWechatAutoReplyList()
    },
    async getWechatAccount () {
      // Get wechat account
      try {
        const { rcode, data } = await wechatAccountApi.getWechatAccountByUserId(this.user.userid)
        if (rcode === 701) {
          this.wechatAccount = {
            accountName: '',
            originalId: '',
            appId: '',
            appSecret: '',
            token: '',
            encodingAesKey: '',
            domain: '',
            offlineTpl: '',
            refundTpl: '',
            abnormalTpl: '',
            stockTpl: '',
            remarks: ''
          }
          return
        }

        this.wechatAccount = {
          accountName: data.account_name,
          originalId: data.original_id,
          userId: this.user.userid,
          appId: data.app_id,
          appSecret: data.app_secret,
          token: data.token,
          encodingAesKey: data.encoding_aes_key,
          domain: data.domain,
          offlineTpl: data.offline_tpl,
          refundTpl: data.refund_tpl,
          abnormalTpl: data.abnormal_tpl,
          stockTpl: data.stock_tpl,
          remarks: data.remarks
        }
      } catch (err) {
        console.log(err)
        this.$message({
          message: '获取商户公众号配置失败',
          type: 'error'
        })
      }
    },
    async getMenu () {
      try {
        const { rcode, data, msg } = await wechatAccountApi.getWechatAccountMenu(this.user.userid)
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }

        this.menu = data
        this.menuStr = JSON.stringify(data, null, '\t')
      } catch (err) {
        console.log(err)
        this.$message({
          message: '获取公众号菜单失败',
          type: 'error'
        })
      }
    },
    async getWechatAutoReplyList () {
      try {
        const { rcode, data, msg } = await wechatAutoReplyApi.getWechatAutoReplyList({
          page: 1,
          pageSize: 10,
          filters: {
            userid: this.user.userid,
            app_id: this.wechatAccount.appId
          }
        })
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }

        this.autoReplyList = data.list
        this.autoReplyCount = data.count
      } catch (err) {
        console.log(err)
        this.$message({
          message: '获取公众号自动回复列表失败',
          type: 'error'
        })
      }
    },
    onDialogClose () {
      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wechat-account-setting-wrapper {

  .empty-wrapper{
    text-align: center;

    button {
      margin-top: 10px;
    }
  }

  .content-wrapper {

    .row-list {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;

      .row {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 10px;
        width: 100%;
        font-size: 16px;

        .label {
          display: block;
          width: 150px;
          text-align: end;
          flex: 1;
        }
        .value {
          flex: 2;
          margin-left: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .operation-box {
      display: flex;
      justify-content: center;
      margin-top: 10px;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/user/components/DialogWechatAccountSetting.vue